import { PAGE_URLS } from '../../constants/hrefLinks';
import { userStateData } from '../../data/userStateData';
import './style.scss';

interface AppFooterProps {
	activeIndex: number
	remainActive?: boolean | undefined
}

function AppFooter({activeIndex, remainActive}: AppFooterProps) {

	return (
		<div className="app-footer">
			<div className='app-footer-button'>
				<img
					className='app-footer-button-img'
					src={activeIndex === 0 ? '/imgs/icons/footer/icon-footer-explore-active.svg' : '/imgs/icons/footer/icon-footer-explore-inactive.svg'}
					alt='Explore icon'
					onClick={() => {
						if (activeIndex !== 0 || remainActive === true) {
							window.location.replace(`${PAGE_URLS.APP_EXPLORE}`)
						}
					}}
				/>
			</div>
			<div className='app-footer-button'>
				<img
					className='app-footer-button-img'
					src={activeIndex === 1 ? '/imgs/icons/footer/icon-footer-community-active.svg' : '/imgs/icons/footer/icon-footer-community-inactive.svg'}
					alt='Community icon'
					onClick={() => {
						if (activeIndex !== 1 || remainActive === true) {
							window.location.replace(`${PAGE_URLS.APP_COMMUNITIES}`)
						}
					}}
				/>
			</div>
			<div className='app-footer-button'>
				<img
					className='app-footer-button-img'
					src={activeIndex === 2 ? '/imgs/icons/footer/icon-footer-marketplace-active.svg' : '/imgs/icons/footer/icon-footer-marketplace-inactive.svg'}
					alt='Market place icon'
				/>
			</div>
			<div className='app-footer-button'>
				<img
					className='app-footer-button-img'
					src={activeIndex === 3 ? '/imgs/icons/footer/icon-footer-lessons-active.svg' : '/imgs/icons/footer/icon-footer-lessons-inactive.svg'}
					alt='Lesson icon'
					// onClick={() => {
					// 	if (activeIndex !== 3 || remainActive === true) {
					// 		window.location.replace(`${PAGE_URLS.APP_LESSONS}`)
					// 	}
					// }}
				/>
			</div>
			<div 
				className='app-footer-button'
				onClick={() => {
					if (activeIndex !== 4 || remainActive === true) {
						// window.location.replace(`${PAGE_URLS.APP_PROFILE}`)
						// window.location.replace(`${PAGE_URLS.APP_PROFILE_USER}`)
						window.location.replace(`${PAGE_URLS.APP_PROFILE_USER}?id=${userStateData.getId()}`)
					}
				}}
			>
				<img
					className='app-footer-button-img'
					// src={activeIndex === 4 ? '/imgs/icons/footer/icon-footer-profile-active.svg' : '/imgs/icons/footer/icon-footer-profile-inactive.svg'}
					src={'/imgs/icons/footer/icon-footer-profile-inactive.svg'}
					alt='Profile icon'
				/>
			</div>
		</div>
	)
}

export default AppFooter